var _path, _path2, _path3, _path4, _circle, _circle2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#032838",
    d: "M14.5,6c0-0.345,0.047-0.677,0.121-1H2v2h12.621C14.547,6.677,14.5,6.345,14.5,6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#032838",
    d: "M14.5,18c0-0.346,0.047-0.677,0.121-1H2v2h12.621C14.547,18.677,14.5,18.346,14.5,18z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#032838",
    d: "M4.5,12c0-0.345,0.047-0.677,0.121-1H2v2h2.621C4.547,12.677,4.5,12.345,4.5,12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#032838",
    d: "M13.379,11c0.074,0.323,0.121,0.655,0.121,1s-0.047,0.677-0.121,1H22v-2H13.379z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#006899",
    cx: 19,
    cy: 6,
    r: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#006899",
    cx: 9,
    cy: 12,
    r: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#006899",
    cx: 19,
    cy: 18,
    r: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsActive);
export default __webpack_public_path__ + "static/media/settings_active.e5064c11.svg";
export { ForwardRef as ReactComponent };